export const ADMIN_COMMUNICATION_LINK = 'https://mbcustomerservice.zendesk.com/hc/en-us/requests/new';
